const duration = {
    xslow: '500ms',
    slow: '400ms',
    normal: '300ms',
    fast: '200ms',
    xfast: '150ms',
};
const easing = {
    accelerate: 'cubic-bezier(0.3, 0, 1, 1)',
    decelerate: 'cubic-bezier(0, 0, 0, 1)',
    standard: 'cubic-bezier(0.2, 0, 0, 1)',
};
export const motion = {
    duration,
    easing,
};
